import _ from 'lodash';
import { refComputingTypeService } from '@/services';
import { GUID_EMPTY } from '@/helpers';
import {
    GET_BY_ACCOUNT_ID,
    GET_BY_ID,
    ADD,
    UPDATE,
    DELETE
} from "./actions.type";
import {
    GET_ALL_REQUEST,
    GET_ALL_SUCCESS,
    GET_ALL_FAILURE,
    GET_BY_ID_REQUEST,
    GET_BY_ID_SUCCESS,
    GET_BY_ID_FAILURE,
    CLEAR_ITEMS,
    CLEAR_CURRENT_ITEM,
    UPDATE_CURRENT_ITEM
} from "./mutations.type";

function getBlankRefComputingType() {
    return {
        refComputingTypeId: GUID_EMPTY,
        accountId: GUID_EMPTY,
        shortName: "",
        name: "",
        notes: "",
        displayOrder: null,
        itServiceCount: 0
    };
}

export const refcomputingtypes = {
    namespaced: true,
    state: {
        status: {
            loading: false,
            loaded: false,
            failed: false,
            error: null
        },
        items: [],
        currentRefComputingType: getBlankRefComputingType()
    },
    getters: {

    },
    actions: {
        [GET_BY_ACCOUNT_ID]({ commit }, accountId) {
            return new Promise((resolve, reject) => {
                commit(GET_ALL_REQUEST);

                refComputingTypeService.getByAccount(accountId)
                    .then(
                        refComputingTypes => {
                            commit(GET_ALL_SUCCESS, refComputingTypes);
                            resolve(refComputingTypes);
                        },
                        error => {
                            commit(GET_ALL_FAILURE, error);
                            reject(error);
                        }
                    );
            });
        },
        [GET_BY_ID]({ commit }, refComputingTypeId) {
            return new Promise((resolve, reject) => {
                commit(GET_BY_ID_REQUEST);

                return refComputingTypeService.getById(refComputingTypeId)
                    .then(
                        refComputingType => {
                            commit(GET_BY_ID_SUCCESS, refComputingType);
                            resolve(refComputingType);
                        },
                        error => {
                            commit(GET_BY_ID_FAILURE, error);
                            reject(error);
                        }
                    );
            });
        },
        [ADD]({ dispatch, commit }, refComputingType) {
            return refComputingTypeService.add(refComputingType);
        },
        [UPDATE]({ dispatch, commit }, refComputingType) {
            return refComputingTypeService.update(refComputingType);
        },
        [DELETE]({ dispatch, commit }, refComputingType) {
            return refComputingTypeService.deleteRefComputingType(refComputingType);
        },
    },
    mutations: {
        [GET_ALL_REQUEST](state) {
            state.status = { loading: true };
        },
        [GET_ALL_SUCCESS](state, refComputingTypes) {
            state.status = { loaded: true };
            state.items = refComputingTypes;
        },
        [GET_ALL_FAILURE](state, error) {
            state.status = { failed: true, error };
            state.items = [];
        },
        [GET_BY_ID_REQUEST](state) {
            state.status = { loading: true };
        },
        [GET_BY_ID_SUCCESS](state, refComputingType) {
            state.status = { loaded: true };
            state.currentRefComputingType = refComputingType;
        },
        [GET_BY_ID_FAILURE](state, error) {
            state.status = { failed: true, error };
            state.currentRefComputingType = getBlankRefComputingType();
        },
        [CLEAR_ITEMS](state) {
            state.items = [];
        },
        [CLEAR_CURRENT_ITEM](state) {
            state.currentRefComputingType = getBlankRefComputingType();
        },
        [UPDATE_CURRENT_ITEM](state, { field, value }) {
            // see https://ypereirareis.github.io/blog/2017/04/25/vuejs-two-way-data-binding-state-management-vuex-strict-mode/
            Object.assign(state.currentRefComputingType, {
                [field]: value
            });
        },
    }
}
